export const NavData = [
    {
        title: "Home",
        url: "#",
        cName: "nav-links",
        icon: "fa-solid fa-house"
    },
    {
        title: "About",
        url: "#about",
        cName: "nav-links",
        icon: "fa-solid fa-circle-info"
    },
    {
        title: "Projects",
        url: "#Projects",
        cName: "nav-links",
        icon: "fa-solid fa-briefcase"
    },
    {
        title: "Contact",
        url: "#Contact",
        cName: "nav-links",
        icon: "fa-solid fa-address-book"
    },
]
